var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Styles
import styled from 'styled-components';
export var InputBase = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=InputBase.js.map